@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.service

import org.example.project.utils.All

fun All.mitBerechneterPlatzBelegung(): All {
    val modul = modulTyp.uppercase()

    val werte = when (modul) {
        "CCG1" -> when {
            belegt -> All(vpCCG1 = "1")
            else -> All(vpCCG1 = "1")
        }

        "CCG2" -> when {
            halbBelegt -> All(vpCCG1 = "1", vpCCG2 = "1")
            belegt -> All(vpCCG2 = "1")
            else -> All(vpCCG2 = "2")
        }

        else -> All()
    }

    return copy(
        vpCCG1 = werte.vpCCG1,
        vpCCG2 = werte.vpCCG2
    )
}
